import React, { Component } from 'react'
import TextInput from 'components/UI/TextInput'
import { Button } from 'components/UI/Button'
import {
  FormContainer,
  FormContent,
  FormFooter,
  FormTitle,
  FormWrapper,
  Description
} from './styles'

interface IFormProps {
  email: string
  onResendCode: (email: string) => void
  onChangeEmail: () => void
  onSubmit: (code: string) => void
}

interface IFormState {
  code: string
  erroredCode: string
}

const MAX_CODE_LENGTH = 6

class CheckYourEmailForm extends Component<IFormProps, IFormState> {
  constructor(props: IFormProps) {
    super(props)

    this.state = {
      code: '',
      erroredCode: ''
    }
  }

  render() {
    const { email, onChangeEmail } = this.props
    const { erroredCode } = this.state

    return (
      <FormWrapper>
        <FormContainer>
          <FormTitle>Check Your Email</FormTitle>
          <Description>
            We have sent a {`${MAX_CODE_LENGTH}`}-letter code to {`${email}`}.
            Please verify email by typing the code below:
          </Description>
          <FormContent>
            <TextInput
              name={'code'}
              maxLength={MAX_CODE_LENGTH}
              placeholder={`Enter Your ${MAX_CODE_LENGTH}-letter Code`}
              errorLabel={erroredCode || ''}
              handleChange={this.onChangeCode}
            />
          </FormContent>
          <FormFooter>
            <Button variant={'text'} onClick={this.handleResendCode}>
              Send a New Code
            </Button>
            <Button variant={'text'} onClick={onChangeEmail}>
              Change Email
            </Button>
          </FormFooter>
        </FormContainer>
      </FormWrapper>
    )
  }

  private handleResendCode = () => {
    const { email, onResendCode } = this.props
    onResendCode(email)
  }

  private onChangeCode = (name: string, value: string) => {
    this.setState({ code: value, erroredCode: '' }, () => {
      const { code } = this.state
      const { onSubmit } = this.props

      if (code && code.length === MAX_CODE_LENGTH) {
        onSubmit(code)
      }
    })
  }
}

export default CheckYourEmailForm
